import { render, staticRenderFns } from "./Movimentacoes.vue?vue&type=template&id=807bc8da&"
import script from "./Movimentacoes.vue?vue&type=script&lang=js&"
export * from "./Movimentacoes.vue?vue&type=script&lang=js&"
import style0 from "./Movimentacoes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Pipelines\\release\\06.04\\maintenance\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('807bc8da')) {
      api.createRecord('807bc8da', component.options)
    } else {
      api.reload('807bc8da', component.options)
    }
    module.hot.accept("./Movimentacoes.vue?vue&type=template&id=807bc8da&", function () {
      api.rerender('807bc8da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/Materiais/Movimentacoes.vue"
export default component.exports